import { AppText } from "~/ui/app-text"
import { ShareRoomFragment } from "~/__generated__/graphql"
import { useSearchParams } from "react-router-dom"
import { cn } from "~/common/cn"
import { TextureGrainBackground } from "./components/texture-grain-background"
import { Logo } from "~/landing/components/logo"
import { RoomContentCard } from "./room-content-card"

export const ShareRoomCardScreen = (): JSX.Element => {
  const [searchParams] = useSearchParams()
  const roomTag = document.querySelector("meta[name=room-data]")
  const roomDataContent = roomTag?.getAttribute("content")
  const roomData = roomDataContent ? (JSON.parse(roomDataContent) as ShareRoomFragment) : null

  return (
    <div
      className={cn(
        "z-[-2] mx-auto flex w-[360px] flex-col gap-4 overflow-hidden bg-gradient-to-b from-[#0047FF] to-base-blue pb-2 pt-6",
        {
          "rounded-[12px]": searchParams.get("rounded") === "true",
        }
      )}
    >
      <TextureGrainBackground className="z-[-1]" />

      {/* Logo Section */}
      <div className="flex justify-center">
        <Logo
          className="h-[40px]"
          analyticsProps={{
            room_id: roomData?.id || undefined,
            room_handle: roomData?.roomHandle || undefined,
          }}
        />
      </div>

      {/* Title Section */}
      <div className="flex justify-center">
        <AppText
          variant="display"
          className="px-1 text-center text-[25px] leading-[25px] text-base-white"
        >
          JOIN THE GROUP CHAT
        </AppText>
      </div>

      {/* Content Card */}
      <div className="flex justify-center">
        {roomData && <RoomContentCard roomData={roomData} compact={true} />}
      </div>
    </div>
  )
}

export default ShareRoomCardScreen
